import Cookies from 'js-cookie'
import _LO from '@/utils/LodopIndex'
const env = process.env.NODE_ENV

const TokenKey = env === 'development'?'ZdBarcode-Token':'ZdClound-Token';

const IidKey = 'TID'

const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (env === 'production') {
    return Cookies.set(TokenKey, token,{domain: '.zhidiancloud.com'})
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function setTid(id) {
  return Cookies.set(IidKey, id, { expires: 60 })
}

export function getTid() {
  return Cookies.get(IidKey)
}

export function removeToken() {
  if (env === 'production') {
    return Cookies.remove(TokenKey,{domain: '.zhidiancloud.com'})
  } else {
    return Cookies.remove(TokenKey)
  }
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

export function setExpiresState(state) {
  return Cookies.set('ExpiresState', state)
}

export function removeExpiresState() {
  return Cookies.remove('ExpiresState')
}

export function getPrinter() {
  const print = _LO.getPrintList()?_LO.getPrintList():[]
  let printers = [{ index: -1, label: '系统默认打印机' }].concat(print)
  return printers
}